import { Grid } from "@mui/material";
import CustomSnackbar from "../Common/CustomSnackbar";
import { useParserConfigReport } from "./hooks/useParserConfigReport";
import PayloadInputSection from "./PayloadInputSection";
import PayloadResultTable from "./PayloadResultTable";
import { useSnackbar } from "../Common/hooks/useSnackbar";

const ParserConfigReport: React.FC = () => {
  const { showSuccess, showError, snackbarProps } = useSnackbar();

  const {
    payloadText,
    payloadData,
    loading,
    selectedParserConfig,
    parserConfigList,
    handlePayloadChange,
    handleParserConfigChange,
    handlePayloadUpload,
  } = useParserConfigReport(1);

  const handleParse = async () => {
    try {
      await handlePayloadUpload();
      showSuccess("Parse işlemi başarılı");
    } catch (error) {
      showError(error as Error);
    }
  };

  return (
    <>
      <Grid container direction={"row"}>
        <PayloadInputSection
          payloadText={payloadText}
          selectedParserConfig={selectedParserConfig}
          parserConfigList={parserConfigList}
          onPayloadChange={handlePayloadChange}
          onParserConfigChange={handleParserConfigChange}
          onParse={handleParse}
          onError={showError}
          disabled={loading}
        />

        <PayloadResultTable data={payloadData} loading={loading} />
      </Grid>

      <CustomSnackbar {...snackbarProps} />
    </>
  );
};

export default ParserConfigReport;
